module.exports = __webpack_public_path__ + "img/accessory_shirt_07.2a4cef57.svg";